import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  const allItems = [{ label: "Accueil", href: "/" }, ...items];

  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Fil d'Ariane"
      className="flex items-center flex-wrap gap-1 text-sm text-slate-500 py-3"
    >
      {allItems.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1">
          {idx > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />}
          {idx === 0 ? (
            <Link
              to="/"
              className="flex items-center gap-1 hover:text-blue-600 transition-colors"
              data-testid="breadcrumb-home"
            >
              <Home className="w-3.5 h-3.5" />
              <span className="sr-only">Accueil</span>
            </Link>
          ) : idx === allItems.length - 1 ? (
            <span
              className="text-slate-800 font-medium truncate max-w-[200px] sm:max-w-xs"
              data-testid={`breadcrumb-current`}
            >
              {item.label}
            </span>
          ) : (
            <Link
              to={item.href}
              className="hover:text-blue-600 transition-colors truncate max-w-[120px]"
              data-testid={`breadcrumb-${idx}`}
            >
              {item.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
